import { Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { Chevron } from '~/components/Icon/v2/Chevron';
import styles from './ChallengeGuideCta.module.scss';
export const ChallengeGuideCta = () => (
  <BaseCard color="muted" size="large" className={styles.root}>
    <Heading level={5} className={styles.title}>
      <T name="citizen_home_challenge_guide" />
    </Heading>
    <div className={styles.link}>
      <T name="citizen_home_challenge_guide_btn" />
      <Chevron />
    </div>
  </BaseCard>
);
